<template>
  <div>
  <user-remove-warning
  :showModal="warningShow"
  @cancel="cancelRemove"
  @approve="approveRemove"
  />
  <div class="c-table-container">
    <UserListItem v-for="user in users" :user="user"
    @editMemberHandler="editMember"
    @removeMemberHandler="removeMember" :key="user.email" />
  </div>
</div>
</template>

<script>
import HrVenueService from '@/services/hrvenue.service';
import { showNotification } from '@/static/helpers';

export default {
  name: 'UserList',
  props: {
    modals: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      warningShow: false,
      id: null,
    };
  },
  mounted() {
  },
  methods: {
    cancelRemove() {
      if (this.warningShow) {
        this.warningShow = false;
      }
    },
    async approveRemove() {
      const { deleted } = await HrVenueService.deleteUser(this.id);
      if (deleted) {
        this.$emit('fetchUserList', { force: true });
        this.$emit('getUserRight');
        if (this.warningShow) {
          this.warningShow = false;
          setTimeout(() => {
            showNotification(
              this.resource['label.Success'],
              this.resource['user.RemoveUserSuccessMessage'],
              'success',
            );
          }, 300);
        }
      } else {
        this.warningShow = false;
      }
    },
    editMember(email) {
      this.modals.clonedEditUser = [];
      const user = this.users.find((user) => user.email === email);
      this.modals.editMemberModal.name = user.name;
      this.modals.editMemberModal.surname = user.surname;
      this.modals.editMemberModal.email = email;
      this.modals.editMemberModal.id = user.id;
      this.modals.editMemberModal.userRoleId = user.userRoleId;
      this.modals.editMemberModal.show = true;
      this.modals.clonedEditUser.push({ ...this.modals.editMemberModal });
    },
    removeMember(id) {
      this.id = id;
      this.warningShow = true;
    },
  },
  components: {
    UserListItem: () => import('./UserListItem.vue'),
    UserRemoveWarning: () => import('./UserRemoveWarning.vue'),
  },
};
</script>

<style lang="scss" scoped>
  .c-table-container{
    border-left: 1px solid #E4E4E4;
    border-right: 1px solid #E4E4E4;
  }
</style>
